import { Grid2, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  isOutlined?: boolean;
}

function CardWrapper({ children, isOutlined }: Props) {
  const theme = useTheme();
  return (
    <Grid2
      position="relative"
      size={1}
      height="300px"
      border={
        isOutlined
          ? `2px solid ${theme.palette.primary.main}`
          : `1px solid ${theme.palette.darkerLightGrey.main}`
      }
      boxShadow={3}>
      {children}
    </Grid2>
  );
}

export default CardWrapper;
